import { render, staticRenderFns } from "./UserMonitor.vue?vue&type=template&id=f9e88396&scoped=true"
import script from "./UserMonitor.vue?vue&type=script&lang=js"
export * from "./UserMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e88396",
  null
  
)

export default component.exports